import { Select, type SelectProps } from "./Select";
import classNames from "classnames";

import cls from "./CalendarLikeSelect.module.less";
import { MenuItem } from "~/common/mui";

type Props = SelectProps & {
  itemsPerRow: number;
};
export const CalendarLikeSelect = ({ itemsPerRow, MenuProps = {}, ...rest }: Props) => {
  return (
    <Select
      variant={"outlined"}
      MenuProps={{
        ...MenuProps,
        style: {
          ...MenuProps.style,
          // @ts-ignore
          "--column-amount": itemsPerRow,
        },
        classes: {
          ...MenuProps?.classes,
          list: classNames(cls.list, MenuProps?.classes?.list),
        },
      }}
      {...rest}
    />
  );
};

CalendarLikeSelect.Item = MenuItem;
